<template>
  <div class='buy-vip-modal'  @touchmove.prevent="handleTouchMove">
    <div class='a-overlay' :class="{'a-hidden': !isShow}" @click.stop='handleOverlayClick'></div>
    <div class='modal-content' :class="{'hidden': !isShow}">
      <div class='modal-content-detail'>
        <div class="vip-name a-white fx-col fx-m-center" :class='levelClass'>
          <div class='vip-logo'></div>
          <div class='a-text-22 a-text-bold'>{{levelName}}会员</div>
          <div class='a-text-14 vip-value'>{{levelName}}会员总价值{{vipInfo.oriPrice}}元</div>
          <img src='https://cdn.133.cn/gtgj/vipcard/vipFlag.png' alt='' class='icon-flag' />
        </div>
        <!-- 礼包选择 -->
        <div class='gift-bag fx-col fx-c-center'>
          <div class='fx-center classify-title'>
            <img src='https://cdn.133.cn/gtgj/vipcard/title_l.png' alt='' class='icon-left-line' />
            <div class='a-text-15 a-lightblack'>买会员送礼包</div>
            <img src='https://cdn.133.cn/gtgj/vipcard/title_r.png' alt='' class='icon-right-line' />
          </div>
          <div class='a-text-10 a-gray' style='line-height: 1'>两大礼包任选其一</div>
          <div class='bag-list'>
            <div class='bag-item' v-for="(item, index) in bagInfo" :key='index' @click="handleSelectBag(item.type)">
              <div class='fx-row fx-m-between fx-c-center'>
                <div class='bag-name a-text-14'>{{item.title}}</div>
                <div class='chose-radio' :class="{'checked': selectType == item.type}"></div>
              </div>
              <div class='bag-content-item a-text-12' v-for="(conItem, idx) in item.itemList" :key="idx">{{conItem.content}}</div>
              <div class='bag-notice a-text-10' v-if='item.desc'>{{item.desc}}，每月最高返现5次</div>
              
            </div>
          </div>
        </div>
        <!-- 购买按钮 -->
        <div class='pay-btn fx-center a-text-18' @click='handleBuy'>确认开通  ¥{{vipInfo.savePrice}}/年</div>
      </div>
    </div>
  </div>
</template>

<script>
const _all = new Map([
  ['1', ['normal', '普通']],
  ['2', ['silver', '白银']],
  ['3', ['gold', '黄金']],
  ['4', ['platinum', '白金']],
  ['5', ['diamond', '钻石']]
]);

export default {
  props: {
    currentIndex: {
      type: [String, Number],
      required: true
    },
    isShow: {
      type: Boolean,
      default: false
    },
    bagInfo: {
      type: Array,
      default: () => {
        return [];
      }
    },
    vipInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      selectType: -1
    }
  },
  computed: {
    levelClass() {
      return _all.get(this.currentIndex) && _all.get(this.currentIndex)[0];
    },
    levelName() {
      return _all.get(this.currentIndex) && _all.get(this.currentIndex)[1];
    }
  },
  methods: {
    handleTouchMove() {
      return;
    },
    handleSelectBag( param ) {
      this.selectType = param == this.selectType ? -1 : param+'';
    },
    handleOverlayClick() {
      this.$emit('change-modal-status',{
        type: 'vip',
        value: false
      });
      this.selectType = -1;
    },
    handleBuy() {
      if ( this.selectType !== -1 ) {
        // console.log(this.selectType)
      } else {
        this.$emit('change-modal-status',{
          type: 'vip',
          value: false
        })
        this.$popup({
          title: '温馨提示',
          content: '请先选择礼包'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

.buy-vip-modal {
  @mixin setSize($iWidth, $iHeight) {
    width: $iWidth * $px;
    height: $iHeight * $px;
  }
  .icon-rights {
    @include setSize(28, 28);
    margin-bottom: 6 * $px;
  }
  .icon-flag {
    @include setSize(30, 39);
    position: absolute;
    right: 21 * $px;
    top: -2 * $px;
  }
  .icon-left-line {
    @include setSize(24, 3);
  }
  .icon-right-line {
    @include setSize(24, 3);
  }
  .modal-content { 
    width: 86.1%;
    // top: 24 * $px; 
    // bottom: auto;
    bottom: 27%;
    right: 0;
    left: 0;
    margin: 0 auto;
    &.hidden {
      bottom: 0;
    }
  }
  .modal-content-detail {
    width: 100%;
    margin: 0;
    padding-bottom: 20 * $px;
    .vip-name {
      line-height: 1;
      padding-left: 84 * $px;
      position: relative;
      height: 94 * $px;
      border-radius: 12 * $px 12 * $px 0 0;
      .vip-logo {
        @include setSize(65, 68);
        position: absolute;
        left: 13 * $px;
        top: 17 * $px;
      }
      @mixin flagBg( $type ) {
        .vip-logo {
          background: url('https://cdn.133.cn/gtgj/vipcard/#{$type}.png') no-repeat center top;
          background-size: 100% 100%;
        }
      }
      &.gold {
        background-image: linear-gradient(134deg, #F5D472 0%, #F5BD4E 100%);
        @include flagBg('goldFlag');
      }
      &.platinum {
        background-image: linear-gradient(134deg, #C2CDED 0%, #93A0C7 100%);
        @include flagBg('platinumFlag');
      }
      &.diamond {
        background-image: linear-gradient(-45deg, #1D1E1F 0%, #393A3D 100%);
        @include flagBg('diamondFlag');
      }
      
      .vip-value {
        margin-top: 11 * $px;
        opacity: 0.8;
      }
    }
    .classify-title {
      margin-top: 8 * $px;
      div {
        margin: 0 6 * $px;
      }
    }
    .bag-item { 
      width: 268 * $px;
      box-sizing: border-box;
      position: relative;
      background: #FFFBF5;
      border-radius: 6 * $px;
      border: 4 * $px solid #FFECCC;
      margin-top: 14 * $px;
      padding: 5 * $px 10 * $px 5 * $px 14 * $px;
      .bag-name {
        color: #C7773D;
        line-height: 20 * $px;
      }
      .chose-radio {
        @include setSize(18, 18);
        background: url('https://cdn.133.cn/gtgj/vipcard/unselect.png') no-repeat center top;
        background-size: 100% 100%;
        &.checked {
          background-image: url('https://cdn.133.cn/gtgj/vipcard/isSelect.png');
        }
      }
      .bag-name, .chose-radio {
        margin-bottom: 4 * $px;
      }
      .bag-content-item {
        color: #BA792F;
        line-height: 17 * $px;
        margin-top: 2 * $px;
      }
      .bag-notice { 
        line-height: 14 * $px;
        margin-top: 4 * $px;
        color: #DAB589;
      }
    }
    
    .pay-btn {
      height: 48 * $px;
      margin: 26 * $px 32 * $px 0;
      color: #93632D;
      margin-top: 30 * $px;
      background-image: linear-gradient(90deg, #F7E1B2 0%, #F4CA89 100%);
      border-radius: 24 * $px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/projects/vipCard/pages/home/components/buy-vip-modal.vue